import { ICellRendererComp, ICellRendererParams } from "ag-grid-community";
import { Objects } from "src/modules/utils/shared/objects";

// Nur horizontale Kürzung zählt; ein Pixel Toleranz gleicht Rundungsunterschiede des Browsers aus
export function isCellTextTruncated(element: HTMLElement): boolean {
    return element != null && element.scrollWidth > element.clientWidth + 1;
}

// AG Grid prüft die Kürzung nur bei Spalten ohne cellRendererSelector; daher setzen auch einfache Textzellen ihren Tooltip selbst
export class SmTableTextCellRenderer implements ICellRendererComp {
    private eGui: HTMLSpanElement;

    init(params: ICellRendererParams): void {
        this.eGui = document.createElement("span");
        this.eGui.className = "sm-table-text-cell";
        this.update(params);
    }

    getGui(): HTMLElement {
        return this.eGui;
    }

    refresh(params: ICellRendererParams): boolean {
        this.update(params);
        return true;
    }

    private update(params: ICellRendererParams): void {
        let value: unknown = params.value;
        let tooltip = params.valueFormatted ?? (typeof value == "string" ? value : null);
        this.eGui.textContent = params.valueFormatted ?? Objects.toString(value);
        params.setTooltip?.(tooltip ?? "", () => isCellTextTruncated(this.eGui));
    }
}
